const LOAD_LITERALS = 'LOAD_LITERALS';
const defaultState = {};

const langReducer = (state = defaultState, { type, payload }) => {
  switch (type) {
    case LOAD_LITERALS:
      return payload;
    default:
      return state;
  }
};

export default langReducer;

export const loadLiterals = literals => ({
  type: LOAD_LITERALS,
  payload: literals,
});
